import withHasPermission from '../../hoc/withHasPermission';
import { Permission } from '../../permissions/permission';
import Certificates from './Certificates';

const Certs = withHasPermission(() => {
    return <Certificates title={'Certificates'} icon={'fa-scroll'} />;
}, Permission.Root_Certificates);

export default Certs;
